var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Block404"},[_c('h1',[_vm._v("404")]),_vm._v("页面没有找到 ")])
}]

export { render, staticRenderFns }